import { getPreferredExperience } from '@/console/host/experience-storage';
import { ExperienceId } from '@/console/host/experience.types';
import { isModernRouteSupported } from '@/console/host/route-support';

export const resolveExperience = (
  pathname: string,
  storedPreference: ExperienceId = getPreferredExperience(),
): ExperienceId => {
  if (storedPreference !== 'modern') return 'classic';

  return isModernRouteSupported(pathname) ? 'modern' : 'classic';
};
